import React, { FC } from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import {
  Text,
  Stack,
  Card,
  Button,
  PresentationItem,
  HorizontalLine,
} from '@components'

import { GuildPresentationsScreenUpcomingPresentationsSection_guild$key } from './__generated__/GuildPresentationsScreenUpcomingPresentationsSection_guild.graphql'

export const GuildPresentationsScreenUpcomingPresentationsSection: FC<{
  guild: GuildPresentationsScreenUpcomingPresentationsSection_guild$key
}> = ({ guild }) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildPresentationsScreenUpcomingPresentationsSection_guild on Guild
      @refetchable(
        queryName: "GuildPresentationsScreenUpcomingPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingPresentations: presentationsByEventTimeSelection(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "GuildPresentationsScreenUpcomingPresentationsSection_guild_upcomingPresentations"
          ) {
          edges {
            node {
              ...PresentationItem_presentation
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.upcomingPresentations.edges.length === 0) {
    return null
  }

  return (
    <>
      <Stack direction='horizontal' gap={4} alignItems='center'>
        <Text size={4} variant='cardHeading'>
          Upcoming Presentations
        </Text>

        <HorizontalLine variant='cardHeading' />
      </Stack>

      {data.upcomingPresentations.edges.map((edge) => {
        return (
          <Card variant='main' gap={4} key={edge.cursor}>
            <PresentationItem presentation={edge.node} numberOfLines={8} />
          </Card>
        )
      })}

      {hasNext && (
        <Button
          variant='secondary'
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Text variant='buttonSecondary' size={4}>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Text>
        </Button>
      )}
    </>
  )
}
